import approvals from './approvals';
import invitation from './invitation';
import shell from './shell';
import tasks from './tasks';

let messages = Object.assign({}, approvals, invitation, shell, tasks);

export default messages;
